import { createApi } from '@reduxjs/toolkit/query/react';
import type {
    GetMemberSelectedShippingProvidersApiResponse,
    UpdateMemberSelectedShippingProvidersApiRequest
} from 'tradera/state/services/types/webapi-selling-generated';

import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';

export const preferredShippingProvidersApi = createApi({
    reducerPath: 'preferredShippingProvidersApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getSelectedShippingProviders: builder.query<
            GetMemberSelectedShippingProvidersApiResponse,
            void
        >({
            query: () => {
                return `/api/webapi/selling/member-selected-shipping-providers`;
            }
        }),
        setSelectedShippingProviders: builder.mutation<
            void,
            UpdateMemberSelectedShippingProvidersApiRequest
        >({
            query: (body) => {
                return {
                    url: `/api/webapi/selling/member-selected-shipping-providers`,
                    method: 'POST',
                    body
                };
            },
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                // optimistic update
                const patchResult = dispatch(
                    preferredShippingProvidersApi.util.updateQueryData(
                        'getSelectedShippingProviders',
                        undefined,
                        (draft) => {
                            Object.assign(draft, {
                                selectedShippingProviders:
                                    // find available shipping providers that match an id in the array of selected shipping providers we post
                                    draft.availableShippingProviders?.filter(
                                        (availableShippingProvider) =>
                                            arg.selectedShippingProviders?.includes(
                                                availableShippingProvider.providerSettingId ??
                                                    ''
                                            )
                                    )
                            });
                        }
                    )
                );

                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            }
        })
    })
});

export const {
    useGetSelectedShippingProvidersQuery,
    useSetSelectedShippingProvidersMutation
} = preferredShippingProvidersApi;
